import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { SwapsDto } from '../../types/dto/Swap.dto';
import { formatToISwap, Metadatas } from '../../utils/swap';
import { useWeb3React } from '@web3-react/core';
import { fetchAllTokensMetadata } from '../../services/swap';
import { useKiwiClient } from './useClient';
import { ISwap } from '../../types/swap';
import { getNFTsMetadata } from '../../services/OpenSea/getNFTsMetadata';

interface SwapDetails {
  loading: boolean;
  error?: string;
  data?: ISwap;
}

export const useSwap = (swapId: string): SwapDetails => {
  const [metadatas, setMetadatas] = useState<Metadatas>({});
  const [metadataLoading, setMetadataLoading] = useState(false);
  const [OSmetadatas, setOSMetadatas] = useState({});
  const { chainId, account } = useWeb3React();
  const apolloClient = useKiwiClient();

  const vars = {
    filters: JSON.stringify({
      orderBy: 'createdAt',
      where: { id: { value: swapId } },
    }),
  };

  const { loading, error, data } = useQuery<SwapsDto>(FETCH_SWAP, {
    client: apolloClient,
    variables: vars,
  });

  useEffect(() => {
    if (data?.swaps && data.swaps.length > 0) {
      setMetadataLoading(true);

      getNFTsMetadata([data.swaps[0]], chainId).then((nftMetadatas) => {
        setOSMetadatas(nftMetadatas);
        setMetadataLoading(false);
      });

      // Load metadata for each token address used in swap
      fetchAllTokensMetadata([data.swaps[0]]).then((nfts) => {
        setMetadatas(nfts);
        setMetadataLoading(false);
      });
    }
  }, [data?.swaps && data.swaps.length]);

  return {
    loading: loading || metadataLoading,
    error: error?.message,
    data:
      data?.swaps && data?.swaps.length > 0
        ? formatToISwap(data?.swaps[0], metadatas, OSmetadatas, account)
        : undefined,
  };
};

const FETCH_SWAP = gql(
  `query Swap($filters: String!) {
        swaps(filters: $filters) {
        id
        swapId
        contract
        status
        createdAt
        updatedAt
        canceledBy {
          id
        }
        rejectedBy {
          id
        }
        initiatorNfts {
          id
          token {
            id
          }
          tokenUri
          identifier
          amount
        }
        initiatorEther
        secondUserNfts {
          id
          token {
            id
          }
          tokenUri
          identifier
          amount
        }
        secondUserEther
        from {
          id
        }
        to {
          id
        }
      }
    }
    `,
);
